import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-249fd68c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rpk" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "PaginationHolder" }
const _hoisted_5 = { class: "PaginationHolder" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_rpk_filters = _resolveComponent("rpk-filters")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_new_limit = _resolveComponent("new-limit")!
  const _component_new_pagination = _resolveComponent("new-pagination")!
  const _component_rpk_list_item = _resolveComponent("rpk-list-item")!
  const _component_list = _resolveComponent("list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Список РПК" }),
      _createVNode(_component_the_button, {
        class: "primary small text",
        disabled: _ctx.state.is_export_loading,
        loading: _ctx.state.is_export_loading,
        onClick: _ctx.exportRPK
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Выгрузить в Excel ")
        ]),
        _: 1
      }, 8, ["disabled", "loading", "onClick"])
    ]),
    _createVNode(_component_rpk_filters, {
      loading: _ctx.state.is_loading,
      onSearch: _ctx.onSearch,
      onReset: _ctx.onReset,
      class: "my-5"
    }, null, 8, ["loading", "onSearch", "onReset"]),
    (_ctx.data_state.rpk.is_failed && !_ctx.data_state.rpk.failure.error_state.is_cancel)
      ? (_openBlock(), _createBlock(_component_failed_fetch, {
          key: 0,
          loading: _ctx.data_state.rpk.is_loading,
          text: "При получении списка РПК произошла ошибка",
          "error-message": _ctx.data_state.rpk.failure.error_state.message,
          "error-url": _ctx.data_state.rpk.failure.error_state.url,
          "error-status": _ctx.data_state.rpk.failure.error_state.status,
          onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadRPKList(_ctx.data_state.rpk.pagination.current_page)))
        }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_new_limit, {
              disabled: _ctx.data_state.rpk.is_loading,
              "total-items": _ctx.data_state.rpk.pagination.total_items,
              value: _ctx.filter_state.limit,
              onChange: _ctx.onLimitChange
            }, null, 8, ["disabled", "total-items", "value", "onChange"]),
            _createVNode(_component_new_pagination, {
              class: "ml-6",
              disabled: _ctx.data_state.rpk.is_loading,
              "current-page": _ctx.data_state.rpk.pagination.current_page,
              "total-pages": _ctx.data_state.rpk.pagination.total_pages,
              onChangePage: _ctx.onChangePage
            }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
          ]),
          _createVNode(_component_list, {
            loading: _ctx.state.is_loading,
            items: _ctx.data_state.rpk.list
          }, {
            item: _withCtx(({ item }) => [
              _createVNode(_component_rpk_list_item, {
                item: item,
                onDelete: _ctx.deleteRPK
              }, null, 8, ["item", "onDelete"])
            ]),
            _: 1
          }, 8, ["loading", "items"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_new_limit, {
              disabled: _ctx.data_state.rpk.is_loading,
              "total-items": _ctx.data_state.rpk.pagination.total_items,
              value: _ctx.filter_state.limit,
              onChange: _ctx.onLimitChange
            }, null, 8, ["disabled", "total-items", "value", "onChange"]),
            _createVNode(_component_new_pagination, {
              class: "ml-6",
              disabled: _ctx.data_state.rpk.is_loading,
              "current-page": _ctx.data_state.rpk.pagination.current_page,
              "total-pages": _ctx.data_state.rpk.pagination.total_pages,
              onChangePage: _ctx.onChangePage
            }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
          ])
        ]))
  ]))
}